import { Box, Container, Typography } from '@mui/material'
import AppointmentSearchAutocomplete, {
    FilteredResults
} from 'src/pages/MUIBased/Appointments/components/AppointmentSearchAutocomplete'
import { AppointmentProfile } from 'src/types'

interface AppointmentSearchPanelProps {
    offerings: AppointmentProfile[]
    returnResults: (results: FilteredResults | undefined) => void
}

const AppointmentSearchPanel = ({
    offerings,
    returnResults
}: AppointmentSearchPanelProps) => {
    const getOptionLabel = (option: string | AppointmentProfile) => {
        if (typeof option === 'string') {
            return option
        }
        return option.label
    }

    return (
        <Box
            sx={{
                py: 4,
                px: {
                    xs: 0,
                    sm: 2,
                    md: 4
                },
                mb: 4,
                bgcolor: 'rgba(255,255,255, 0.5)'
            }}
        >
            <Container>
                <Typography
                    sx={{ fontSize: '20px', lineHeight: '24px', mb: 2 }}
                >
                    What appointment are you looking for?
                </Typography>
                <AppointmentSearchAutocomplete
                    name="appointmentSearch"
                    label="Search appointments"
                    options={offerings}
                    getOptionLabel={getOptionLabel}
                    returnResults={returnResults}
                />
            </Container>
        </Box>
    )
}

export default AppointmentSearchPanel
